var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1074 5.67629V3",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20312 5.67629V3",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62793 7.93853V6.79153C7.62793 6.15808 8.14144 5.64453 8.77489 5.64453H11.4511C12.0846 5.64453 12.5981 6.15804 12.5981 6.79153V7.93853",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0732 14.4595H10.9263V13.3125H9.39696V14.4595H8.25V15.9888H9.39696V17.1358H10.9263V15.9888H12.0732V14.4595Z",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71777 3H14.2163C14.8496 3 15.3631 3.51343 15.3631 4.14682",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1743 21.6913H6.14678C5.51343 21.6913 5 21.1778 5 20.5445V11.3701C5 9.47001 6.54029 7.92969 8.44039 7.92969H11.8808C13.7808 7.92969 15.3212 9.47001 15.3212 11.3701V20.5445C15.3212 21.1778 14.8077 21.6913 14.1743 21.6913Z",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7874 11.0273H6.52441V19.4372H13.7874V11.0273Z",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.55616C18 8.18961 17.4865 8.70315 16.853 8.70315C16.2196 8.70315 15.7061 8.18965 15.7061 7.55616C15.7061 6.9227 16.853 5.64453 16.853 5.64453C16.853 5.64453 18 6.9227 18 7.55616Z",
    stroke: "#737373",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGel);
export default __webpack_public_path__ + "static/media/gel.f38179f76bf9ecd67cb524a18a93f9f0.svg";
export { ForwardRef as ReactComponent };